const CACHE_DURATION = 5 * 60 * 1000;

class CacheService {
  constructor() {
    this.cache = {};
  }

  set(key, data) {
    this.cache[key] = {
      data,
      timestamp: Date.now()
    };
  }

  get(key) {
    const cachedItem = this.cache[key];
    if (!cachedItem) return null;
    
    const isExpired = Date.now() - cachedItem.timestamp > CACHE_DURATION;
    if (isExpired) {
      delete this.cache[key];
      return null;
    }
    
    return cachedItem.data;
  }

  clear(key) {
    if (key) {
      delete this.cache[key];
    } else {
      this.cache = {};
    }
  }

  clearAll() {
    this.cache = {};
  }

  bufferToBase64(buffer) {
    return Buffer.from(buffer, 'base64');
  }
}

export const cacheService = new CacheService(); 